import VideoLayout from "../Video/VideoLayout";
import { Helmet } from "react-helmet";
import SecondHeader from "../../Header/SecondHeader";
import LivestreamHeader from "./Controls/LivestreamHeader";
import { useState } from "react";
import { useGetAllDevicesQuery } from "../../../Redux/service/Devices";
import usePermission from "../../../hooks/usePermission";
import AccessDenied from "../../AccessDenied";

//  TODO: WebRTC Will be used insted of HLS URL
const buildVehicleOptions = (feeds) => {
  const grouped = {};

  feeds.forEach((feed) => {
    if (!grouped[feed.vehicle]) {
      grouped[feed.vehicle] = [];
    }
    grouped[feed.vehicle].push({
      title: `Channel ${feed.channel}`,
      value: `${feed.vehicle}-${feed.channel}`,
      url: feed.hlsUrl,
    });
  });

  return Object.keys(grouped).map((vehicle) => ({
    title: vehicle,
    value: vehicle,
    children: grouped[vehicle],
  }));
};

const LiveStreaming = () => {
  const { data: vehiclesData, isLoading } = useGetAllDevicesQuery();

  const [layoutType, setLayoutType] = useState(1);
  const [isPlaying, setIsPlaying] = useState(true);
  const [selectedFeeds, setSelectedFeeds] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);

  const { view } = usePermission("LIVESTREAM");
  const cameraFeeds = [];

  if (!view) {
    return <AccessDenied />;
  }

  if (vehiclesData && vehiclesData.length > 0) {
    vehiclesData.forEach((vehicle) => {
      for (let i = 1; i <= 9; i++) {
        cameraFeeds.push({
          vehicle: vehicle.name || vehicle.id,
          channel: `c${i}`,
          hlsUrl:
            "blob:https://stream.softsprint.ae/c3c0960c-0a96-4325-a4dc-958083bcb6cf",
        });
      }
    });
  }

  const vehicleOptions = buildVehicleOptions(cameraFeeds);

  const handleLayoutChange = (newLayoutType) => {
    let maxFeeds = 4;
    switch (newLayoutType) {
      case 1:
        maxFeeds = 1;
        break;
      case 2:
        maxFeeds = 4;
        break;
      case 3:
        maxFeeds = 6;
        break;
      case 4:
        maxFeeds = 9;
        break;
      case 5:
        maxFeeds = 8;
        break;
      default:
        maxFeeds = 4;
        break;
    }

    // Trim extra selected feeds if needed
    setSelectedFeeds((prev) => {
      const trimmed = prev.slice(0, maxFeeds);
      const trimmedValues = trimmed.map(
        (feed) => `${feed.vehicle}-${feed.channel}`
      );
      setSelectedValues(trimmedValues);
      return trimmed;
    });
    setLayoutType(newLayoutType);
  };

  return (
    <>
      <Helmet>
        <title>Live Stream</title>
        <meta name="description" content="Users" />
      </Helmet>
      <SecondHeader />
      <LivestreamHeader
        layoutType={layoutType}
        setLayoutType={handleLayoutChange}
        setIsPlaying={setIsPlaying}
        vehicles={vehicleOptions}
        feeds={cameraFeeds}
        setSelectedFeeds={setSelectedFeeds}
        selectedValues={selectedValues}
        isLoading={isLoading}
      />
      <div>
        <VideoLayout
          cameraFeeds={selectedFeeds}
          layoutType={layoutType}
          isPlaying={isPlaying}
          mode={"streaming"}
        />
      </div>
    </>
  );
};

export default LiveStreaming;
